import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';
import { message } from 'antd';
import moment from 'moment';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import ventaClienteService from '../../../service/ventas/ventaClienteProductoService';
import productoService from '../../../service/administracion/productoService';
import vendedorService from '../../../service/administracion/vendedorService';

import clienteService from '../../../service/administracion/clienteService';
import monedaService from '../../../service/administracion/monedaService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from "../../../service/administracion/almacenService";
import proyectoService from '../../../service/administracion/proyectoService';

import fenologicaService from '../../../service/administracion/fenologicaService';
import cultivoService from '../../../service/administracion/cultivoService';
import categoriaService from '../../../service/administracion/categoriaService';


import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            clientes: [],
            establecimientos: [],
            monedas: [],
            almacenes: [],
            productos: [],

            vendedores: [],
            proyectos: [],
            cultivos: [],
            fenologicas: [],
            categorias: [],
            segmentoFilter: [],
            filter: {
                tipoReporte: 3,
                idEstablecimiento: 0,
                idAlmacen: 0,
                idVendedor: 0,
                tipoVendedor: 0,
                idProyecto: 0,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idProducto: 0,
                idCategoria: 0,
                lote: '',
                idCultivo: 0,
                idFenologica: 0,
                cliente: '',
                idMoneda: 0,
                idCliente: 0,
                referencia: '',
                tipoComprobante: 1,
                ...FILTER
            },
            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            tipoReporte: 1,
            idEstablecimiento: 0,
            idAlmacen: 0,
            idVendedor: 0,
            tipoVendedor: 0,
            idProyecto: 0,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            producto: '',
            idCategoria: 0,
            lote: '',
            idCultivo: 0,
            idFenologica: 0,
            cliente: '',
            idMoneda: 0,
            referencia: '',
            idCliente: 0,
            idProducto: 0,

            tipoComprobante: 1,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = async (property, value) => {

       const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };
    
        const { fechaInicioStr, fechaFinStr } = filter;
    
        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
          const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
          const fin = moment(fechaFinStr, 'DD/MM/YYYY');
    
          const meses = fin.diff(inicio, 'months', true);
    
          if (meses > MAX_MESES) {
            message.error('El rango máximo permitido es de 18 meses');
            return; // ⛔ no actualiza el estado
          }
        }
    
        this.setState({ filter: filter });

        if (property == 'idEstablecimiento') {
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            filter.idAlmacen = 0;

            this.setState({ almacenes, filter });
        }

        if (property == 'idCultivo') {
            const fenologicas = await fenologicaService.obtenerPorCultivoId(value);
            filter.idFenologica = 0;

            this.setState({ fenologicas, filter });
        }

        else {
            this.setState({ filter });
        }

    };

    handleExportExcel = async () => {
        this.setState({
            loadingExcel: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaClienteService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas por Cliente.xlsx");
        });
    };

    handleExportPdf = async () => {
        this.setState({
            loadingPdf: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaClienteService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas por Cliente.pdf");
        });

    };

    handlePagination = () => {
        this._handlePagination(this.state.filter);
    }


    fetchSearch = async (value) => {
        if (value != null && value.length >= 4) {
            var lista = [];
            if (this.state.productos.length > 0) {
                lista = this.state.productos.filter((item) => {
                    return global
                        .formatSearch(`${item.nombre} - ${item.codigoReferencia}`)
                        .match(global.formatSearch(value));
                }).slice(0, 75);
            }
            if (lista.length == 0) {
                var response = await productoService.autocomplete(value)
                this.setState({
                    productos: response ? response : [],
                });

            } else {
                this.setState({
                    productos: lista ? lista : [],
                });
            }

        }
    };




    handleData = async (id) => {
        const familiasCategoria = await categoriaService.listarPorIdClase(id);
        var categorias = this.state.categorias.concat(familiasCategoria);
        this.setState({
            categorias
        });
    }


    async componentDidMount() {
        this._initPagination(this.state.filter, ventaClienteService.paginacion);
        const clientes = await clienteService.listar();
        const monedas = await monedaService.listar();
        const productos = [];//await productoService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const proyectos = await proyectoService.listar();
        const cultivos = await cultivoService.listar();
        const categorias = await categoriaService.listar();

        if (monedas !== undefined)
            monedas.splice(0, 0, { id: '0', nombre: "MONEDA ORIGINAL" });

        this.setState({
            loadingSource: false,
            establecimientos: establecimientos ? establecimientos : [],
            vendedores: vendedores ? vendedores : [],
            proyectos: proyectos ? proyectos : [],
            cultivos: cultivos ? cultivos : [],
            productos: productos ? productos : [],
            clientes: clientes ? clientes : [],
            categorias: categorias ? categorias : [],
            monedas: monedas ? monedas : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte General de Ventas"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    establecimientos={this.state.establecimientos}
                    monedas={this.state.monedas}
                    almacenes={this.state.almacenes}
                    productos={this.state.productos}
                    vendedores={this.state.vendedores}
                    proyectos={this.state.proyectos}
                    cultivos={this.state.cultivos}
                    fenologicas={this.state.fenologicas}
                    categorias={this.state.categorias}
                    onChange={this.handleChange}
                    onSearch={this.fetchSearch}
                    onData={this.handleData}

                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    onExportExcel={this.handleExportExcel}
                    onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}